<template>
  <div class="app-layout">
    <common-header />
    <router-view />
    <common-footer />
    <notifi-dialog v-model:visible="mainStore.dialogs.notifiCard" />
  </div>
</template>

<script setup lang="ts">
import { CommonHeader } from '@/components/CommonHeader';
import { CommonFooter } from '@/components/CommonFooter';
import { TechWorkDialog } from '@/components/Dialogs/TechWorkDialog';
import {
  useDialogStore,
  usePoolsStore,
  useStakingStore,
  useStore,
} from '@/store';
import { onBeforeMount, computed } from 'vue';
import { useDialog } from 'primevue/usedialog';
import { AcceptTermsDialog } from '@/components/Dialogs/AcceptTermsDialog';
import { NotifiDialog } from '@/components/Dialogs/NotifiDialog';
import {
  showNoLpDialog,
  showInstallMobileAppDialog,
  handleInstallMobileAppDialog,
  isTimeToShowInstallMobileAppDialog,
  showWelcomeL2Dialog,
} from '@/composables/useDialogService';
import { delay } from '@/utils';
import { detectAndroid } from '@/composables/useMobileDetection';
import { CORRECT_CHAIN_ID } from '@/constants/networks';

const dialogStore = useDialogStore();
const dialog = useDialog();

const mainStore = useStore();
const poolsStore = usePoolsStore();
const stakingStore = useStakingStore();

onBeforeMount(() => {
  displayTechWorkDialog();
  displayInstallMobileAppDialog();
  displayTermAndConditionsDialog();
  displayWelcomeL2Dialog();
});

function displayTermAndConditionsDialog() {
  if (!mainStore.showTermsAndConditions.value) {
    return;
  }

  dialog.open(AcceptTermsDialog, {
    props: {
      modal: true,
      contentStyle: { maxWidth: '483px' },
      draggable: false,
      closable: false,
      showHeader: true,
    },
    onClose: (options) => {
      if (options?.data.isStakesPage) {
        delay(200).then(() => {
          checkAndShowNoLpDialog();
        });
      }
    },
  });
}

function checkAndShowNoLpDialog() {
  if (
    stakingStore.deposits.length === 0 &&
    !poolsStore.hasLpCoins &&
    !poolsStore.stakingLpDontShow
  )
    showNoLpDialog(dialog);
}

function displayTechWorkDialog() {
  if (!mainStore.dialogs.techWork) return;

  dialogStore.setHasBack(false);
  dialog.open(TechWorkDialog, {
    props: {
      modal: true,
      style: { width: '400px' },
      contentClass: 'step',
      draggable: false,
      closable: false,
      showHeader: dialogStore.showHeader,
      header: 'Technical work every Thursday',
    },
  });
}

function displayInstallMobileAppDialog() {
  if (detectAndroid() && isTimeToShowInstallMobileAppDialog()) {
    handleInstallMobileAppDialog();
    showInstallMobileAppDialog(dialog);
  }
}

const isMovement = computed(() => {
  return [126, 177].includes(CORRECT_CHAIN_ID);
});

function displayWelcomeL2Dialog() {
  if (!mainStore.showWelcomeL2Dialog.value || isMovement) {
    return;
  }

  const onClose = () => {
    mainStore.showWelcomeL2Dialog.value = false;
  };

  showWelcomeL2Dialog(dialog, onClose);
}
</script>

<style scoped>
.app-layout {
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  min-height: 100vh;
}
</style>
